var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    { staticClass: "ivu-mt", attrs: { bordered: false, shadow: "never" } },
    [
      _c("div", { staticClass: "explain-box flex item-center" }, [
        _c("i", { staticClass: "el-icon-s-opportunity" }),
        _c("div", { staticClass: "explain-content" }, [
          _c("div", { staticClass: "explain-title" }, [
            _vm._v(_vm._s(_vm.explainTitle)),
          ]),
          _c("div", { staticClass: "explain-text" }, [
            _vm._v(_vm._s(_vm.explainText)),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }